import {SmartTriggerConfigurationProvider} from "../../context/smartTriggerConfigurationProvider";
import {useAuth} from "../../../../providers/AuthProvider";
import {useEffect, useState} from "react";
import {getSmartTriggerConfiguration, toSmartTriggerUIConfiguration} from "../../service/smartTriggerService";
import {SmartTriggerConfiguration, SmartTriggerUiConfiguration} from "../../types";
import SmartTriggerFlowConfigurationComponent from "./smartTriggerFlowConfigurationComponent";
import './smartTriggerFlowConfigurationComponent.css';
import {useParams, useSearchParams} from "react-router-dom";
import {Loader} from "../../../loader/Loader";
import {AuthContextType} from "../../../../types/types";


export type SmartTriggerConfigurationComponentProps = {
    smartTriggerId?: string

}

export type SmartTriggerConfigurationComponentState = {
    isLoading: boolean,
    configuration: SmartTriggerUiConfiguration | null,
    errors: string[]
}

const newSmartTriggerConfiguration: SmartTriggerConfiguration = {
    "id": "",
    "createdBy": "",
    "activeStatus": "INACTIVE",
    "name": "",
    "author": "",
    "description": "",
    "tags": [],
    "processors": [
        {
            "id": "startNode",
            "position": {
                "x": 300,
                "y": 100
            },
            "data": {
                "name": "startNode",
                "description": "It's a startNode",
                "previous": null,
                "next": "addNode"
            },
            "type": "start"
        },
        {
            "id": "addNode",
            "position": {
                "x": 478,
                "y": 550
            },
            "data": {
                "name": "addNode",
                "description": "addNode",
                "previous": "startNode",
                "next": null
            },
            "type": "add"
        }
    ]
}

async function getConfiguration(action: string | null, id: string | undefined, authContext: AuthContextType) {
    if (id === 'new') {
        return newSmartTriggerConfiguration;
    }
    return getSmartTriggerConfiguration(authContext, id as string);
}

export function SmartTriggerConfigurationComponent({smartTriggerId}: SmartTriggerConfigurationComponentProps) {

    const {id} = useParams();
    const [searchParams] = useSearchParams();
    const action = searchParams.get('action')
    const authContext = useAuth();

    const [state, setState] = useState<SmartTriggerConfigurationComponentState>({
        isLoading: true,
        configuration: null,
        errors: []
    });


    useEffect(() => {
        const fetchSmartTriggerAndSetPayloads = async () => {
            const configuration = await getConfiguration(action, id, authContext);
            const uiConfiguration = toSmartTriggerUIConfiguration(configuration);
            setState(s => ({...s, isLoading: false, configuration: uiConfiguration}));
        }

        fetchSmartTriggerAndSetPayloads()
            .catch(error => {
                setState({...state, isLoading: false, errors: ["Something went wrong"]})
            })
    }, [id, authContext, action]);
    if (state.isLoading) {
        return <Loader/>
    }
    if (state.errors.length > 0) {
        return <h1>{state.errors[0]}</h1>
    }
    if (state.configuration === null) {
        return <h1>Something went wrong</h1>
    }

    return (<SmartTriggerConfigurationProvider configuration={state.configuration}>
        <SmartTriggerFlowConfigurationComponent/>
    </SmartTriggerConfigurationProvider>);
}
